import { Injector } from '@angular/core';
import { PlatformService } from '../platform.service';
import { ScannerMobileService } from './scanner-mobile.service';
import { ScannerWebService } from './scanner-web.service';
import { AbstractScanner } from './scanner.types';
import { BarcodeFormat } from '@zxing/library';

export function scannerFactory(
  platformService: PlatformService,
  injector: Injector
): AbstractScanner {
  if (platformService.isNativeMobile()) {
    return injector.get(ScannerWebService); // in case we'll need native implementation
  }
  return injector.get(ScannerWebService);
}
